import "../styles/banner.css";

const Banner = () => {
  const scrollTo = (id) => {
    document.getElementById(id)?.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <section className="banner">
      <div className="banner-content">
        <p>Espacio familiar, comunitario y creativo</p>

        <p>
          <small>
            Es un espacio de encuentro y ocio especialmente diseñado para amantes
            de las artes y el sabor del café
          </small>
        </p>

        <div className="banner-actions">
          <button
            className="banner-btn banner-btn-secondary"
            onClick={() => scrollTo("menu")}
          >
            <svg
              width="20"
              height="20"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            >
              <line x1="3" y1="6" x2="21" y2="6" />
              <line x1="3" y1="12" x2="21" y2="12" />
              <line x1="3" y1="18" x2="21" y2="18" />
            </svg>
            Menú
          </button>

          <button
            className="banner-btn"
            onClick={() => scrollTo("eventos")}
          >
            Próximos eventos
          </button>
        </div>
      </div>
    </section>
  );
};

export default Banner;
